<template>
  <div class="upgrade">
    <el-row class="line button">
      <el-button icon="el-icon-circle-plus-outline"
                 size="small" @touchstart="openDialog('add')" @click="openDialog('add')">
        新增策略
      </el-button>
      <span style="margin-left: 20px;">
        空间：<el-cascader
        :options="spaceTree"
        @change="changeSpace"
        change-on-select="true"
        clearable
        collapse-tags
        filterable
        placeholder="请选择"
        size="mini"
        style="padding-bottom: 5px; width: 10%"
        v-model="spaceId">
        </el-cascader>
      </span>
      <span style="margin-left: 20px;">
         设备类型：
        <el-select
          placeholder="请选择"
          size="mini"
          @change="changeCategory"
          style="padding-bottom: 5px;width: 10%;"
          clearable
          filterable
          v-model="categoryId">
              <el-option
                :key="item.id"
                :label="item.cnName"
                :value="item.id"
                v-for="item in deviceCategoryList">
              </el-option>
            </el-select>
      </span>
      <span style="margin-left: 20px;">
        设备：
        <el-select
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px;width: 10%;"
          @change="changeDevice"
          clearable
          filterable
          v-model="deviceId">
              <el-option
                :key="item.id"
                :label="item.name"
                :value="item.id"
                v-for="item in deviceList">
              </el-option>
            </el-select>
      </span>
      <span style="margin-left: 20px;">
        测点：
        <el-select
          @change="getList"
          collapse-tags
          clearable
          filterable
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px;width: 10%;"
          v-model="pointId">
        <el-option
          :key="item.id"
          :label="item.name"
          :value="item.id"
          v-for="item in pointList">
        </el-option>
        </el-select>
      </span>
    </el-row>
    <ul v-if="upgradeList!=''">
      <li :key="item.id" v-for="item in upgradeList">
        <alarm-upgrade-comp :upgradeData="item" @init="getList" @openDialog="openDialog"></alarm-upgrade-comp>
      </li>
    </ul>
    <no-tactics :name="'告警升级'" @add="() => openDialog('add')" style="text-align: center;margin-top: 10%"
                v-else></no-tactics>

    <function-dialog-component
      :close-click="false"
      :dialog-title="title"
      :dialogVisible.sync="visible"
      @dialogClose="dialogClose"
      center
      width="50vw">
      <div slot="content"
           class="dialog-padding"
           style="height: 55vh;overflow-y: auto">
        <upgrade-details :actionList="data.alarmUpgradeActionList" v-if="operation === 'detail'"></upgrade-details>
        <upgrade-strategy :spaceTree="spaceTree" @receiveData="receiveData"
                          :accountList="accountList"
                          :strategyData="data" v-if="operation === 'add' || operation === 'edit' ">
        </upgrade-strategy>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center;margin-bottom: 15px;">
        <el-button @touchstart="dialogClose" @click="dialogClose" size="mini">关 闭</el-button>
        <el-button @touchstart="commit" @click="commit" size="mini" type="primary" v-if="operation !== 'detail'">保 存</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import UpgradeDetails from "@/views/basic_operations/strategy/alarm_upgrade/UpgradeDetails";
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import AlarmUpgradeComp from "@/views/basic_operations/strategy/alarm_upgrade/AlarmUpgradeComp";
import UpgradeStrategy from "@/views/basic_operations/strategy/alarm_upgrade/UpgradeStrategy";
import {getSpaceTreeData, getTreeHaveDisabled} from "@/network/space-info";
import {editUpgrade, getList, saveUpgrade} from "@/network/alarm-upload";
import {getAccountList} from "@/network/account";
import NoTactics from "@/components/NoTactics";
import {getDeviceCategoryList} from "@/network/device-category";
import {getBySpaceIdAndTypId} from "@/network/device-info";
import {listByDeviceId} from "@/network/device-measuring-point";

export default {
  name: "AlarmUpgrade",
  components: {
    UpgradeDetails, FunctionDialogComponent, AlarmUpgradeComp, UpgradeStrategy, NoTactics
  },
  inject: ['reload'],
  data() {
    return {
      upgradeList: [],
      visible: false,
      edit: true,
      operation: '',
      title: '新增策略',
      showBtn: false,
      strategyData: null,
      spaceId: null,
      // 空间树
      spaceTree: [{
        value: '',
        label: ''
      }],
      data: {},
      accountList: [],
      deviceCategoryList: [],
      categoryId: null,
      deviceList: [],
      deviceId: null,
      pointList: [],
      pointId: null,
    }
  },
  created() {
    this.getList();
    this.getSpaceTreeData();
    this.getAccountList();
    // 获取设备类型
    this.getDeviceCategoryList();
  },
  methods: {
    changeSpace() {
      this.pointId=null
      this.deviceId=null
      this.pointList=[]
      this.getList()
      this.getDeviceList();
    },
    // 获取设备类型
    getDeviceCategoryList() {
      getDeviceCategoryList().then(res => {
        if (res.code === 0) {
          this.deviceCategoryList = res.data;
          return;
        }
      });
    },
    changeCategory() {
      this.pointId=null
      this.deviceId=null
      this.pointList=[]
      this.getList()
      this.getDeviceList();
    },
    // 获取设备
    getDeviceList() {
      getBySpaceIdAndTypId(this.spaceId, this.categoryId).then(res => {
        this.deviceList = res.data
      });
    },
    changeDevice(){
      this.pointId=null
      this.getList()
      this.getPointList();
    },
    //  获取设备的测点
    getPointList() {
      this.pointList=[]
      listByDeviceId(this.deviceId).then(res => {
        if (res.code === 0) {
          this.pointList=res.data
        }
      })
    },
    getList() {
      getList(this.spaceId,this.categoryId,this.deviceId,this.pointId).then(res => {
        this.upgradeList = res.data
      })
    },
    onMouseOver() {
      this.showBtn = true
    },
    onMouseLeave() {
      this.showBtn = false
    },
    openDialog(operation, data) {
      this.operation = operation;
      if (data) {
        this.data = data;
      }
      if (operation === 'add') {
        this.title = '新增策略'
      } else if (operation === 'detail') {
        this.title = data.spaceName + "-" + data.deviceCategoryName + "-" + (data.deviceName ? data.deviceName : "全部设备")
          + "-" + (data.devicePointName ? data.devicePointName : "全部测点")
      } else {
        this.title = '编辑策略'
      }
      this.visible = true;
    },
    //获取级联空间
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          // 将树转换成需要的格式
          this.spaceTree = getTreeHaveDisabled(res.data);
        }
      });
    },
    //数据接收
    receiveData(data) {
      this.strategyData = data;
    },
    //数据保存
    commit() {
      let flag = false;
      if (this.strategyData.allSpaceChecked) {
        this.strategyData.spaceId = "0";
      } else {
        if (this.strategyData.spaceId.length < 1) {
          flag = false;
          this.$message.error("请选择空间或勾选全部空间!")
          return;
        }
      }
      if (this.strategyData.deviceCategoryId !== "") {
        this.strategyData.alarmUpgradeActionList.forEach(action => {
          if (this.$stringIsNotNullAndEmpty(action.startTime)) {
            if (action.startTime !== "0") {
              if (this.$stringIsNotNullAndEmpty(action.time)) {
                if (action.time !== "0") {
                  if (this.$stringIsNotNullAndEmpty(action.intervalTime)) {
                    if (action.intervalTime !== "0") {
                      if (action.noticeAccountIds.length > 0) {
                        if (action.notifyTypeCodes.length > 0) {
                          flag = true;
                        } else {
                          flag = false;
                          this.$message.error("请选择通知方式!")
                        }
                      } else {
                        flag = false;
                        this.$message.error("请选择通知人!")
                      }
                    } else {
                      flag = false;
                      this.$message.error("间隔时间不能为0!")
                    }
                  } else {
                    flag = false;
                    this.$message.error("请填写间隔时间!")
                  }
                } else {
                  flag = false;
                  this.$message.error("持续次数不能为0!")
                }
              } else {
                flag = false;
                this.$message.error("请填写持续次数!")
              }
            } else {
              flag = false;
              this.$message.error("开始时间不能为0!")
            }
          } else {
            flag = false;
            this.$message.error("请填写开始时间!")
          }
        })
      } else {
        this.$message.error("请选择设备类型!")
        return;
      }
      if (flag) {
        if (typeof this.strategyData.spaceId !== 'string') {
          this.strategyData.spaceId = this.strategyData.spaceId[this.strategyData.spaceId.length - 1]
        }
        if (this.strategyData.id) {
          this.editUpgrade();
        } else {
          this.saveUpgrade();
        }
      }
    },
    //新增策略
    saveUpgrade() {
      saveUpgrade(this.strategyData).then(res => {
        if (res.code === 0) {
          this.$message.success("新增成功!")
        } else {
          this.$message.error("新增失败!")
        }
        this.visible = false;
        this.reload();
      })
    },
    //修改策略
    editUpgrade() {
      editUpgrade(this.strategyData).then(res => {
        if (res.code === 0) {
          this.$message.success("编辑成功!")
        } else {
          this.$message.error("编辑失败!")
        }
        this.visible = false;
        this.reload();
      })
    },
    //获取用户列表
    getAccountList() {
      this.accountList = [];
      getAccountList().then(res => {
        if (res.code === 0) {
          this.accountList = res.data;
        }
      })
    },
    dialogClose() {
      this.visible = false;
      this.data = {};
    }
  }
}
</script>

<style scoped>
.upgrade {
  padding: 15px 10px;
}

.upgrade li {
  list-style: none;
  width: 500px;
  height: 378px;
  float: left;
  margin: 10px 10px;
  padding: 30px 40px 30px 40px;
  background-color: rgba(41, 155, 255, .1);
}
</style>
